import { Search, BarChart3, Target, ClipboardList, CheckCircle } from "lucide-react";
import { ParallaxImage, ParallaxText, ScrollFadeIn } from "@/components/Parallax";

const PASOS = [
  {
    id: 1,
    icon: Search,
    title: "Diagnóstico",
    description: "Revisamos antecedentes, títulos, garantías y viabilidad de acción."
  },
  {
    id: 2,
    icon: BarChart3,
    title: "Segmentación",
    description: "Priorizamos los casos según monto, garantía, etapa, ubicación y probabilidad de recupero."
  },
  {
    id: 3,
    icon: Target,
    title: "Estrategia",
    description: "Definimos si corresponde demandar, negociar, ejecutar garantía, avanzar a remate o cerrar fundadamente."
  },
  {
    id: 4,
    icon: ClipboardList,
    title: "Gestión y seguimiento",
    description: "Tramitamos las causas con control de hitos, avances y próximos pasos."
  },
  {
    id: 5,
    icon: CheckCircle,
    title: "Resultado o cierre",
    description: "Orientamos la gestión hacia pago, acuerdo, remate, castigo documentado o incobrabilidad."
  }
];

export default function MetodoSection() {
  return (
    <section id="metodo" data-testid="metodo-section" className="py-20 md:py-28 lg:py-32 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        {/* Header with image */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-20">
          <ParallaxText speed={-0.15} className="relative z-10">
            <ScrollFadeIn direction="left" delay={0}>
              <p className="text-calle-primary-50 text-xs uppercase tracking-[0.3em] mb-4 font-semibold font-body">
                Ruta de recuperación judicial
              </p>
            </ScrollFadeIn>
            <ScrollFadeIn direction="left" delay={0.1}>
              <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-calle-primary leading-[1.1] tracking-[-0.01em]">
                Estrategia
              </h2>
            </ScrollFadeIn>
            <ScrollFadeIn direction="left" delay={0.2}>
              <div className="calle-underline mt-6"></div>
            </ScrollFadeIn>
          </ParallaxText>
          
          <ScrollFadeIn direction="right" delay={0.2}>
            <ParallaxImage
              src="/images/metodo.png"
              alt="Diagrama del método de recuperación judicial"
              className="grayscale-img"
              containerClassName="w-full h-[300px] lg:h-[400px] rounded-sm shadow-2xl"
              speed={0.3}
              scale={0.85}
            />
          </ScrollFadeIn>
        </div>

        {/* Steps with connection */}
        <div className="relative">
          {/* Connection line - desktop */}
          <div className="hidden lg:block absolute top-20 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-transparent via-calle-primary/20 to-transparent z-0" />
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4 relative z-10">
            {PASOS.map((paso, index) => (
              <ScrollFadeIn 
                key={paso.id} 
                direction="up" 
                delay={index * 0.1}
              >
                <ParallaxText speed={-0.02 * (index + 1)}>
                  <div 
                    data-testid={`metodo-paso-${paso.id}`}
                    className="bg-white p-6 rounded-sm border border-gray-200 hover:border-calle-primary/30 transition-all duration-500 hover:shadow-xl group text-center lg:text-left h-full min-h-[340px] flex flex-col hover:-translate-y-2"
                  >
                    <div className="w-14 h-14 rounded-full bg-calle-primary text-white flex items-center justify-center mb-4 mx-auto lg:mx-0 font-heading text-xl font-bold group-hover:scale-110 transition-transform duration-500 shadow-lg">
                      {paso.id}
                    </div>
                    <div className="w-10 h-10 rounded-sm bg-gray-100 flex items-center justify-center mb-4 mx-auto lg:mx-0 group-hover:bg-calle-primary/10 transition-colors duration-300">
                      <paso.icon className="h-5 w-5 text-calle-primary" />
                    </div>
                    <h3 className="font-heading text-lg text-calle-primary mb-2">
                      {paso.title}
                    </h3>
                    <p className="text-gray-500 text-sm leading-relaxed font-body">
                      {paso.description}
                    </p>
                  </div>
                </ParallaxText>
              </ScrollFadeIn>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
